import {PatientCommandParams} from "./PatientCommandParams";
import {Command} from "./Command";
import { NCZIExtension } from '../Interfaces/ncziTypes';

export type GetPatientDPNParams = PatientCommandParams & {
    confirmationId: NCZIExtension
};

export const GetPatientDPN = (params: GetPatientDPNParams): Command => {
    return {
        operation: 'DajPotvrdenieDPN_v1',
        params
    }
}